/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable no-unused-vars */

// ran this thru claudes code refactoring tool

// i am getting this on page refresh
// value (100) is bigger than max (55)
// RangeError: value (100) is bigger than max (55)
// give me the releavnt code to fix this with instructions





import React, { useState, useEffect } from 'react';
import { useSearchParams } from 'react-router-dom';
import { useDispatch, useSelector } from 'react-redux';
import { IoIosArrowForward } from 'react-icons/io';
import { Range } from 'react-range';
import { AiFillStar } from 'react-icons/ai';
import { CiStar } from 'react-icons/ci';
import { BsFillGridFill } from 'react-icons/bs';
import { FaThList } from 'react-icons/fa';

import { price_range_product, query_products } from '../store/reducers/homeReducer';

import Header from '../components/Header';
import Footer from '../components/Footer';
import Products from '../components/products/Products';
import Pagination from '../components/Pagination';
import ShopProductGridListView from '../components/products/ShopProductGridListView';
import ShopBanner from '../components/ShopBanner';
import GetSellerConfig from '../components/GetSellerConfig';

import config from '../config';

const SHOW = 'Show';

const StarRating = ({ value, onSelect }) => {
  const filled = Array.from({ length: 5 }, (_, i) => i < value);
  return (
    <div
      onClick={() => onSelect(value)}
      className="text-orange-500 flex justify-start items-center gap-2 text-xl cursor-pointer"
    >
      {filled.map((f, i) => (f ? <AiFillStar key={i} /> : <CiStar key={i} />))}
    </div>
  );
};

const useSeller = (seller) => {
  const { sellerComponentBackgroundColor } = GetSellerConfig();
  const showPayments = seller.isVisibleSitePayments === SHOW;
  const showRating   = seller.isVisibleSiteRating === SHOW;
  const showUnder    = seller.isVisibleSiteProductsUnderFilter === SHOW;
  const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';') // || [];
 
  return {
    id:                       seller._id,
    primaryColor1:            seller.frontEndPrimaryColor1,
    primaryColor2:            seller.frontEndPrimaryColor2,
    secondaryColor1:          seller.frontEndSecondaryColor1,
    sellerColorSuffixDark:    sellerArrHexOpacityColorSuffixes[0], // || 'FF';
    sellerColorSuffixMedium:  sellerArrHexOpacityColorSuffixes[1],// || '80';
    sellerColorSuffixLight:   sellerArrHexOpacityColorSuffixes[2],// || '1A';
    productTerm:              seller.productTerm,
    productPluralTerm:        seller.productPluralTerm,
    sellerComponentBackgroundColor,
    showPayments,
    showRating,
    showProductsUnderFilter: showUnder,
    showSidebar: showPayments || showRating || showUnder,
    
  };
};

const SearchProducts = () => {
  const sellerFrontendURL    = config.STR_FRONTEND_URL;
  const intPriceRangeStep    = config.INT_FRONTEND_PRICE_RANGE_STEP;

  const [searchParams]       = useSearchParams();
  const category             = searchParams.get('category');
  const mainIngredient       = searchParams.get('mainIngredient');
  const searchValue          = searchParams.get('value');

  const dispatch = useDispatch();
  const { products, latest_product, priceRange, totalProduct, parPage } =
    useSelector((state) => state.home);
  const { seller } = useSelector((state) => state.seller);
  const { sellerComponentBackgroundColor } = GetSellerConfig();
  
  //const s = useSeller(seller);
  const sellerPrimaryColor1 = seller?.frontEndPrimaryColor1;
  const sellerPrimaryColor2 = seller?.frontEndPrimaryColor2;
  const sellerSecondaryColor1 = seller?.frontEndSecondaryColor1;

  // const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';')  || ['FF', '80', '1A'];// || [];// 'FF;80;1A' Darkest is FF, Medium is 80, Lightest is 1A
  // const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes[0]; // || 'FF';
  // const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes[1]; // || '80';
  // const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes[2]; // || '1A';

  const sellerArrHexOpacityColorSuffixes = seller?.hexOpacityColorSuffixes?.split(';');
  
  //console.log('sellerArrHexOpacityColorSuffixes', seller?.hexOpacityColorSuffixes);
  //console.log('hexOpacityColorSuffixes:', seller?.hexOpacityColorSuffixes);

  const sellerColorSuffixDark = sellerArrHexOpacityColorSuffixes?.[0] ?? 'FF';
  const sellerColorSuffixMedium = sellerArrHexOpacityColorSuffixes?.[1] ?? '80';
  const sellerColorSuffixLight = sellerArrHexOpacityColorSuffixes?.[2] ?? '1A';

  const sellerShopName = seller?.shopName;
  const sellerStripePaymentMode = seller?.stripePaymentMode;
  const sellerOtherWebsiteURL1 = seller?.otherWebsiteURL1;
  const sellerOtherWebsiteName1 = seller?.otherWebsiteName1;
  const sellerProductTerm = seller?.productTerm;
  const sellerProductPluralTerm = seller?.productPluralTerm;
  const sellerCompanyPhoneNumber = seller?.phoneNumber;
  const sellerCompanyLogo = seller?.logoImage;
  const sellerCompanyEmailAddress = seller?.emailAddress;
  const sellerCompanyKosherSupervision1 = seller?.kosherSupervision1;
  const sellerCompanyKosherSupervision2 = seller?.kosherSupervision2;
  const sellerMainIngredientPluralTerm = seller?.mainIngredientPluralTerm;
  const sellerTaglineTop1 = seller?.taglineTop1;
  const sellerTaglineTop2 = seller?.taglineTop2;
  const personalServiceTagLine = seller?.personalServiceTagLine;
  const sellerMarketingLine1 = seller?.marketingLine1;
  const sellerHolidayHeader = seller?.holidayHeader;

  const sellerBoolShowSiteWishList = seller?.isVisibleSiteWishlist === 'Show';
  const sellerBoolShowSiteChat = seller?.isVisibleSiteChat === 'Show';
  const sellerBoolShowGalleryImages = seller?.isVisibleGalleryImages === 'Show';
  const sellerBoolShowSitePayments = seller?.isVisibleSitePayments === 'Show';
  const sellerBoolShowsRating   = seller.isVisibleSiteRating === SHOW;
  const sellerBoolSiteProductsUnderFilter    = seller.isVisibleSiteProductsUnderFilter === SHOW;
  
  const showSidebar = sellerBoolShowSitePayments || sellerBoolShowsRating || sellerBoolSiteProductsUnderFilter

  const [priceValues, setPriceValues] = useState([priceRange.low, priceRange.high]);
  useEffect(() => {
    dispatch(price_range_product(sellerFrontendURL));
  }, [sellerFrontendURL]);

  useEffect(() => {
    if (priceRange.high > priceRange.low) {
      setPriceValues([priceRange.low, priceRange.high]);
    }
  }, [priceRange.low, priceRange.high]);

  const [filterOpen, setFilterOpen] = useState(true);
  const [styles, setStyles]         = useState('grid');
  const [pageNumber, setPageNumber] = useState(1);

  const defaultFilters = {
    rating: '',
    sortPrice: '',
    FMP: '',
    cookingMethod: '',
    byThePan: '',
    dietaryRestrictions: '',
    cuisineType: '',
    holiday: '',
  };
  const [filters, setFilters] = useState(defaultFilters);
  const updateFilter = (key) => (value) => setFilters((prev) => ({ ...prev, [key]: value }));

  useEffect(() => {
    dispatch(
      query_products({
        webSiteOrigin: sellerFrontendURL,
        low:  priceValues[0] ?? '',
        high: priceValues[1] ?? '',
        category,
        mainIngredient,
        searchValue,
        pageNumber,
        ...filters,
      })
    );
  }, [
    sellerFrontendURL,
    priceValues[0],
    priceValues[1],
    category,
    mainIngredient,
    searchValue,
    pageNumber,
    filters,
  ]);

  const resetFilter = () => {
    setFilters(defaultFilters);
    dispatch(price_range_product(sellerFrontendURL));
  };

  return (
    <div>
      <Header />
      <section className="">
        <div className="">
          {/* w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto  */}
          <div className="">
            <ShopBanner
              homePage="Home"
              homeLink="/"
              currentPageTop="Search Page"
              currentPageTopLink=""
              currentPageBottom1={searchValue}
              currentPageBottomLink1={`/products/search?category=&&mainIngredient=&&value=${searchValue}`}
              currentPageBottom2=""
              currentPageBottomLink2=""
            />
          </div>
          <div style={{ backgroundColor: sellerComponentBackgroundColor }}>
            <div className="w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto pt-4 border-none border-black">
              <div className={`md:block hidden ${!filterOpen ? 'mb-6' : 'mb-0'}`}>
                <button
                  onClick={() => setFilterOpen((v) => !v)}
                  className="text-center rounded-lg w-full py-2 px-3 text-white"
                  style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                  Filter {sellerProductPluralTerm}
                </button>
              </div>
              <div className="w-full flex flex-wrap">
                <div
                  className={`
                    ${showSidebar ? '' : 'hidden'}
                    w-3/12 md-lg:w-4/12 md:w-full pr-8
                    ${filterOpen ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0'}
                  `}>
                  {sellerBoolShowSitePayments && (
                    <div className="py-2 flex flex-col gap-2">
                      <div className="text-2xl font-bold mb-3" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                        Price
                      </div>
                      {priceRange.high > priceRange.low && (
                        <Range
                          step={intPriceRangeStep}
                          min={priceRange.low}
                          max={priceRange.high}
                          values={[
                            Math.min(Math.max(priceValues[0], priceRange.low), priceRange.high),
                            Math.min(Math.max(priceValues[1], priceRange.low), priceRange.high),
                          ]}
                          onChange={setPriceValues}
                          renderTrack={({ props, children }) => (
                            <div {...props} className="ml-3 w-[92%] h-[6px] bg-slate-200 rounded-full cursor-pointer">
                              {children}
                            </div>
                          )}
                          renderThumb={({ props }) => (
                            <div className="w-[15px] h-[15px] bg-[#059473] rounded-full" {...props} />
                          )}
                        />
                      )}

                      {
                      // <Range
                      //   step={intPriceRangeStep}
                      //   min={priceRange.low}
                      //   max={priceRange.high}
                      //   values={priceValues}
                      //   onChange={setPriceValues}
                      //   renderTrack={({ props, children }) => (
                      //     <div {...props} className="ml-3 w-[92%] h-[6px] bg-slate-200 rounded-full cursor-pointer">
                      //       {children}
                      //     </div>
                      //   )}
                      //   renderThumb={({ props }) => (
                      //     <div className="w-[15px] h-[15px] bg-[#059473] rounded-full" {...props} />
                      //   )}
                      // />
                      }
                  <div>
                    <span className="ml-1 font-bold text-lg" 
                      style={{ color: sellerPrimaryColor1 + sellerColorSuffixMedium }}>
                      ${Math.floor(priceValues[0])} – ${Math.floor(priceValues[1])}
                    </span>
                  </div>
                </div>
              )}
              {sellerBoolShowsRating && (
                <div className="py-3 flex flex-col gap-2">
                  <div className="text-2xl font-bold mb-1" 
                    style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                    Rating
                  </div>
                  <div className="ml-1 flex flex-col gap-3">
                    {[5, 4, 3, 2, 1].map((v) => (
                      <StarRating key={v} value={v} onSelect={updateFilter('rating')} />
                    ))}
                    <StarRating value={0} onSelect={updateFilter('rating')} />
                  </div>
                </div>
              )}

              {(sellerBoolShowSitePayments || sellerBoolShowsRating) && (
                <button
                  onClick={resetFilter}
                  style={{ backgroundColor: sellerPrimaryColor1 + sellerColorSuffixDark }}
                  className="text-center rounded-lg w-full py-2 px-3 text-white">
                  Reset Filter
                </button>
              )}
              {sellerBoolSiteProductsUnderFilter && (
                <div className="py-5 flex flex-col gap-4 md:hidden">
                  <Products
                    title={`Latest ${sellerProductPluralTerm}`}
                    products={latest_product}
                    parentPage="SearchProducts"
                  />
                </div>
              )}
            </div>
            <div className={`${showSidebar ? 'w-9/12 md-lg:w-8/12' : ''} md:w-full`}>
              <div className={`${showSidebar ? 'pl-8' : ''} md:pl-0`}>
                <div className="bg-white">
                  <div className="px-3 py-1 mb-2 gap-0.5 rounded-lg flex justify-between items-center border"
                      style={{
                          borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                          backgroundColor: sellerPrimaryColor1 + sellerColorSuffixLight,
                      }}>
                    {/*sellerPrimaryColor1 + sellerColorSuffixLight + sellerColorSuffixMedium*/}
                    <div className="text-[18px] font-medium" style={{ color: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                      {totalProduct} {totalProduct === 1 ? sellerProductTerm : sellerProductPluralTerm}
                    </div>
                    <div className="flex justify-center items-center  gap-2 ml-auto">
                      {sellerBoolShowSitePayments && (
                          <select
                              onChange={(e) => updateFilter('sortPrice')(e.target.value)}
                              className="py-1.5 px-2.5 rounded-lg border text-sm font-medium outline-none bg-white cursor-pointer"
                              style={{
                                  color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                  borderColor: sellerPrimaryColor1 + sellerColorSuffixDark,
                              }}>
                              <option value="">Sort By</option>
                              <option value="low-to-high">Price: Low → High</option>
                              <option value="high-to-low">Price: High → Low</option>
                          </select>
                      )}

                      {/* Grid / List toggle */}
                      <div
                          className="flex rounded-lg border overflow-hidden md-lg:hidden"
                          style={{ borderColor: sellerPrimaryColor1 + sellerColorSuffixDark }}>
                          <button
                              onClick={() => setStyles('grid')}
                              className="p-1.5 transition-colors"
                              style={{
                                  backgroundColor: styles === 'grid' ? sellerPrimaryColor1 + sellerColorSuffixLight : 'white',
                                  color: sellerPrimaryColor1 + sellerColorSuffixDark,
                              }}>
                              <BsFillGridFill size={16} />
                          </button>
                          <button
                              onClick={() => setStyles('list')}
                              className="p-1.5 transition-colors"
                              style={{
                                  backgroundColor: styles === 'list' ? sellerPrimaryColor1 + sellerColorSuffixLight : 'white',
                                  color: sellerPrimaryColor1 + sellerColorSuffixDark,
                                  borderLeft: `1px solid ${sellerPrimaryColor1}${sellerColorSuffixDark}`,
                              }}>
                              <FaThList size={16} />
                          </button>
                      </div>
                      {/* Grid / List toggle
                      <div className="hidden flex justify-center items-start gap-4 md-lg:hidden">
                        {[
                          { id: 'grid', Icon: BsFillGridFill },
                          { id: 'list', Icon: FaThList },
                        ].map(({ id, Icon }) => (
                          <div
                            key={id}
                            onClick={() => setStyles(id)}
                            className={`p-2 ${styles === id ? 'bg-slate-300' : ''} hover:bg-slate-300 cursor-pointer rounded-sm`}
                          >
                            <Icon style={{ color: s.primaryColor1 }} />
                          </div>
                        ))}
                      </div>
                      */}
                    </div>
                  </div>
                </div>

                <div className="pb-8">
                  <ShopProductGridListView products={products} styles={styles} />
                </div>
                {totalProduct > parPage && (
                  <Pagination
                    pageNumber={pageNumber}
                    setPageNumber={setPageNumber}
                    totalItems={totalProduct}
                    parPage={parPage}
                    showItem={Math.floor(totalProduct / parPage)}
                  />
                )}
              </div>
            </div>
            </div>
          </div>
          
          </div>
        </div>
      </section>
      <Footer />
    </div>
  );
};

export default SearchProducts;






//my original code
// import React, { useState,useEffect } from 'react';
// import { Link, useSearchParams } from 'react-router-dom';
// import { useDispatch, useSelector } from 'react-redux';

// import { IoIosArrowForward } from "react-icons/io";
// import { Range } from 'react-range';
// import {AiFillStar} from 'react-icons/ai'
// import {CiStar} from 'react-icons/ci' 
// import {BsFillGridFill} from 'react-icons/bs'
// import {FaThList} from 'react-icons/fa'

// import { price_range_product, query_products } from '../store/reducers/homeReducer';

// import Header from '../components/Header';
// import Footer from '../components/Footer';
// import Products from '../components/products/Products';
// import Pagination from '../components/Pagination';
// import ShopProductGridListView from '../components/products/ShopProductGridListView';
// import ShopBanner from '../components/ShopBanner';

// import config from '../config';

// const SearchProducts = () => {
//     const sellerFrontendURL = config.STR_FRONTEND_URL 
//     const intPriceRangeStep = config.INT_FRONTEND_PRICE_RANGE_STEP

//     let [searchParams, setSearchParams] = useSearchParams()
    
//     const category = searchParams.get('category')
//     const mainIngredient= searchParams.get('mainIngredient')
//     const searchValue = searchParams.get('value')

//     const dispatch = useDispatch()
//     const {products, categorys, mainIngredients, priceRange, latest_product, totalProduct, 
//         parPage} = useSelector(state => state.home)
//     const { seller } = useSelector(state => state.seller)
        
//     console.log('products', products)
//     // console.log(latest_product)

//     useEffect(() => { 
//         dispatch(price_range_product(sellerFrontendURL))
//     },[])
    
//     useEffect(() => { 
//         setState({
//             values: [priceRange.low, priceRange.high]
//         })
//     },[priceRange])

//     const [filter, setFilter] = useState(true) 
//     const [state, setState] = useState({values: [priceRange.low, priceRange.high]})
    
//     const sellerId = seller._id 
//     const sellerPrimaryColor1 = seller.frontEndPrimaryColor1
//     const sellerPrimaryColor2 =  seller.frontEndPrimaryColor2
//     const sellerSecondaryColor1 = seller.frontEndSecondaryColor1
//     const sellerProductTerm = seller.productTerm
//     const sellerProductPluralTerm = seller.productPluralTerm
    
//     const sellerBoolShowSitePayments = seller.isVisibleSitePayments === 'Show' ? true : false
//     const sellerBoolShowSiteRating = seller.isVisibleSiteRating === 'Show' ? true : false
//     const sellerBoolShowSiteProductsUnderFilter = seller.isVisibleSiteProductsUnderFilter === 'Show' ? true : false
    
//     let sellerBoolSideBarFilterIsVisible = true
//     if (sellerBoolShowSitePayments || sellerBoolShowSiteRating || sellerBoolShowSiteProductsUnderFilter) {
//         sellerBoolSideBarFilterIsVisible = true
//     } else {
//         sellerBoolSideBarFilterIsVisible = false
//     }

//     const [rating, setRating] = useState('')
//     const [styles, setStyles] = useState('grid')

//     const [pageNumber, setPageNumber] = useState(1)
//     const [sortPrice, setSortPrice] = useState('') 
//     const [FMP, setFmp] = useState('')
//     const [cookingMethod, setCookingMethod] = useState('')
//     const [byThePan, setByThePan] = useState('')
//     const [dietaryRestrictions, setDietaryRestrictions] = useState('')
//     const [cuisineType, setCuisineType] = useState('')
//     const [holiday, setHoliday] = useState('')

//     useEffect(() => { 
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontendURL,
//                 low: state.values[0] || '',
//                 high: state.values[1] || '',
//                 category,
//                 mainIngredient,
//                 FMP,
//                 cookingMethod,
//                 byThePan:'',
//                 dietaryRestrictions:'',
//                 cuisineType:'',
//                 holiday:'',
//                 rating,
//                 sortPrice,
//                 pageNumber,
//                 searchValue
//             })
//          )
//     },[sellerFrontendURL, state.values[0], state.values[1], category, mainIngredient, FMP, cookingMethod, byThePan, dietaryRestrictions, cuisineType, holiday, rating, sortPrice, searchValue, pageNumber])

//     const resetFilter = () => {
//         setRating('')
//         dispatch(
//             query_products({
//                 webSiteOrigin: sellerFrontendURL,
//                 low: state.values[0],
//                 high: state.values[1],
//                 category,
//                 mainIngredient,
//                 FMP: '',
//                 cookingMethod: '',
//                 byThePan:'',
//                 dietaryRestrictions:'',
//                 rating: '',
//                 sortPrice,
//                 pageNumber,
//                 searchValue
//             })
//          )
//          dispatch(price_range_product(sellerFrontendURL))
//          //console.log('reset click')
//     }
   
//     return (
//         <div>
//             <Header/>
//             <section className='py-2'>
//                 <div className='w-[85%] md:w-[80%] sm:w-[90%] lg:w-[90%] h-full mx-auto'>
//                     <div className='mb-2'>
//                         <ShopBanner homePage={'Home'} homeLink={'/'} currentPageTop={'Search Page'} currentPageTopLink={''} 
//                             currentPageBottom1={searchValue} currentPageBottomLink1={'/products/search?category=&&mainIngredient=&&value=' + searchValue} 
//                             currentPageBottom2={''} currentPageBottomLink2={''} />
//                     </div>
//                     <div className={` md:block hidden ${!filter ? 'mb-6' : 'mb-0'} `}>
//                         <button onClick={() => setFilter(!filter)} 
//                             className='text-center rounded-lg w-full py-2 px-3 text-white' style={{backgroundColor:sellerPrimaryColor1}}>
//                             Filter {sellerProductPluralTerm}
//                         </button> 
//                     </div>
//                     <div className='w-full flex flex-wrap'>
//                         <div className={` ${sellerBoolSideBarFilterIsVisible ? '' : 'hidden'} w-3/12 md-lg:w-4/12 md:w-full pr-8 
//                             ${filter ? 'md:h-0 md:overflow-hidden md:mb-6' : 'md:h-auto md:overflow-auto md:mb-0' } `}>
//                             <div className={` ${sellerBoolShowSitePayments ? 'py-2 flex flex-col gap-5' : 'hidden'} `}>
//                                 <h2 className='text-2xl font-bold mb-3' style={{color:sellerPrimaryColor1}}>Price</h2>
//                                 <Range
//                                     step={intPriceRangeStep}
//                                     min={priceRange.low} //  priceRangeMinPrice
//                                     max={priceRange.high} //  priceRangeMaxPrice
//                                     values={(state.values)}
//                                     onChange={(values) => setState({values})}
//                                     renderTrack={({props,children}) => (
//                                         <div {...props} className='w-full h-[6px] bg-slate-200 rounded-full cursor-pointer'>
//                                             {children}
//                                         </div>
//                                     )}
//                                     renderThumb={({ props }) => (
//                                         <div className='w-[15px] h-[15px] bg-[#059473] rounded-full' {...props} />
//                                     )} 
//                                 />  
//                                 <div>
//                                     <span className='font-bold text-lg' style={{color:sellerPrimaryColor1}}>${Math.floor(state.values[0])} - ${Math.floor(state.values[1])}</span>  
//                                 </div>
//                             </div>
//                             <div className={` ${sellerBoolShowSiteRating ? 'py-3 flex flex-col gap-4' : 'hidden'} `}>
//                                 <h2 className='text-2xl font-bold mb-3' style={{color:sellerPrimaryColor1}}>Rating </h2>
//                                 <div className='flex flex-col gap-3'>
//                                     <div onClick={() => setRating(5)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(4)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(3)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(2)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div onClick={() => setRating(1)} className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><AiFillStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div>
//                                     <div className='text-orange-500 flex justify-start items-start gap-2 text-xl cursor-pointer'>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                         <span><CiStar/> </span>
//                                     </div> 
//                                 </div> 
//                             </div>
//                             <button onClick={resetFilter}  style={{backgroundColor:sellerPrimaryColor1}} 
//                                 className={` ${(!sellerBoolShowSitePayments && !sellerBoolShowSiteRating) ? 'hidden' : ''} 
//                                 text-center rounded-lg w-full py-2 px-3 text-white`}>
//                                 Reset Filter
//                             </button> 
//                             <div className={` ${sellerBoolShowSiteProductsUnderFilter ? '' : 'hidden'} py-5 flex flex-col gap-4 md:hidden`}>
//                                 <Products title={'Latest '+ sellerProductPluralTerm} products={latest_product} parentPage={'SearchProducts'} />
//                             </div>
//                         </div>
//                         <div className={` ${sellerBoolSideBarFilterIsVisible ? 'w-9/12 md-lg:w-8/12' : ''}  md:w-full`}>
//                             <div className={` ${sellerBoolSideBarFilterIsVisible ? 'pl-8' : ''}  md:pl-0`}>
//                                 <div className='py-2 bg-white mb-10 px-3 rounded-md flex justify-between items-start border'>
//                                     <h2 className='text-lg font-medium' style={{color:sellerPrimaryColor1}}> 
//                                         {totalProduct}  {sellerProductTerm}
//                                         <span className= {` ${totalProduct > 1 ? '': 'hidden'} `} >s</span>
//                                     </h2>
//                                     <div className='flex justify-center items-center gap-3'>
//                                         <select onChange={(e)=>setSortPrice(e.target.value)} name="" id=""
//                                             className='p-1 border outline-0 font-semibold' style={{color:sellerPrimaryColor1}}>
//                                             <option value="">Sort By</option>
//                                             <option className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} `} value="low-to-high">Low to High Price</option>
//                                             <option className={` ${sellerBoolShowSitePayments ? '' : 'hidden'} `} value="high-to-low">High to Low Price </option>
//                                         </select>
//                                         <div className='flex justify-center items-start gap-4 md-lg:hidden'>
//                                             <div onClick={()=> setStyles('grid')} 
//                                                 className={`p-2 ${styles === 'grid' && 'bg-slate-300'}
//                                                     hover:bg-slate-300 cursor-pointer rounded-sm `} >
//                                                 <BsFillGridFill style={{color:sellerPrimaryColor1}}/>  
//                                             </div>
//                                             <div onClick={()=> setStyles('list')} 
//                                                 className={`p-2 ${styles === 'list' && 'bg-slate-300'} 
//                                                     hover:bg-slate-300 cursor-pointer rounded-sm `} >
//                                                 <FaThList style={{color:sellerPrimaryColor1}}/>  
//                                             </div> 
//                                         </div> 
//                                     </div> 
//                                 </div> 
//                                 <div className='pb-8'>
//                                     <ShopProductGridListView products={products} styles={styles} />  
//                                 </div>
//                                 <div>
//                                 {
//                                     totalProduct > parPage &&  
//                                         <Pagination pageNumber={pageNumber} setPageNumber={setPageNumber} totalItems={totalProduct} 
//                                             parPage={parPage} showItem={Math.floor(totalProduct / parPage )} />
//                                 }
//                                 </div>
//                             </div> 
//                         </div>  
//                     </div>
//                 </div> 
//            </section>
//            <Footer/>
//         </div>
//     );
// };

// export default SearchProducts;




